import { render } from "./NavHeader.vue?vue&type=template&id=9bd4520e&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=9bd4520e&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/Danmarksfugle2.0-frontend/code-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd4520e"]])

export default __exports__